export default __webpack_public_path__ + "static/media/mulherCartaoMobile.3f18a8ec.png";